export interface BiReportConfig {
  ano: string;
  url: string;
}

export const BI_REPORTS: BiReportConfig[] = [
  {
    ano: "2026",
    url: "https://app.powerbi.com/reportEmbed?reportId=5797f2dc-6bc4-477b-9744-65750d3d152b&autoAuth=true&ctid=6f875e12-0f6f-4fff-bdbe-d552254e7653",
  },
  {
    ano: "2025",
    url: "https://app.powerbi.com/reportEmbed?reportId=e7d77d81-29ff-4d43-b70f-d2a7f16b7902&autoAuth=true&ctid=6f875e12-0f6f-4fff-bdbe-d552254e7653",
  },
];

export const getBiReportByAno = (ano?: string) =>
  BI_REPORTS.find((r) => r.ano === String(ano));
